<product-grid [(products)]="pagedProducts" [totalRecords]="totalSize" [category]="category"
    (onPageEmit)="pageEvent($event)" [currentCategory]="currentCategory" (onSortOrderEmit)="sortEvent($event)"
    [sortOption]="sortOrder" [firstLoading]="firstLoading" [newSearchLoading]="newSearchLoading"></product-grid>